export enum ContentActionGq {
  OK = 'OK',
  MERGE = 'MERGE',
  OPTIMIZE = 'OPTIMIZE',
  CREATE = 'CREATE',
  NO_ACTION = 'NO_ACTION', // Legacy
  LOADING = 'LOADING',
  MISSING = 'MISSING',
}
